import "./app.nais.scss";

export const initLogin = (useRecaptcha: boolean, loginLink: string, recaptchaText: string, useTotp: boolean): void => {
    if ($("input[type='checkbox']")[0]) {
        $(function () {
            $("input[type='checkbox']").iCheck({
                checkboxClass: 'icheckbox_flat-green'
            });
        });
    }
    $("#login").on('click', function (e: JQuery.ClickEvent) {
        e.preventDefault();
        let sendFormData: boolean = true;
        let data: {
            username: string;
            password: string;
            remember: string;
            recaptcha: string | null;
            totpCode: string | null;
        } = {
            username: String($("#username").val()),
            password: String($("#password").val()),
            remember: $("#frm-signInForm-remember").is(':checked'),
            recaptcha: null
        };
        if (useRecaptcha) {
            data.recaptcha = window.grecaptcha.getResponse();
            sendFormData = Boolean(data.recaptcha);
            $("#recaptchaMessage").text(sendFormData ? '' : recaptchaText);
        }
        if (useTotp) {
            data.totpCode = String($("#totpCode").val());
        }
        if (sendFormData) {
            $.nette.ajax({
                type: 'post',
                url: loginLink,
                data: data,
                success: function (response: any) {
                    if (!response.errorMessage) {
                        $("#frm-signInForm").submit();
                    }
                    if (response.showTokenModal) {
                        $("#totpModal").modal();
                    }
                }
            });
        }
    });
}

export const throwPNotify = (message: string, mType: NoticeTypeOptions, elementName: string): void => {
    const notice = new window.PNotify({
        animation: "fade",
        text: message,
        delay: 7000,
        mouse_reset: true,
        type: mType,
        styling: "bootstrap3",
        buttons: {
            closer: false,
            sticker: false
        }
    });
    notice.get().on('click', function () {
        notice.remove();
    });
}

window.initLogin = initLogin;
window.throwPNotify = throwPNotify;